import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'
// import axios from 'axios'
Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            props: true,
            name: 'Home',
            component: () =>
                import ('./components/Home/home'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/ServerError',
            name: 'ServerError',
            props: true,
            component: () =>
                import ('./components/Common/500'),
        },
        {
            path: '*',
            name: '404PageNotFound',
            props: true,
            meta: {
                requiresAuth: false,
            },
            component: () =>
                import ('./components/Common/404'),
        },
    ]
})
export default router